// ==========================================
//  LocationModel.js
// ==========================================
export class LocationModel {
  static ALLOWED_KEYS = Object.freeze([
    "id",
    "locationCode",
    "locationName",
    "address",
    "country",
    "state",
    "city",
    "pinCode",
    "status",
    "companyId",
    "company",
    "metadata",
  ]);

  static ALLOWED_METADATA_KEYS = Object.freeze([
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedFlag",
  ]);

  static ID_FIELD = "locationCode";
  static NAME_FIELD = "locationName";

  constructor(data = {}, { isCreation = false } = {}) {
    for (const key of LocationModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        this.metadata = {
          createdAt: null,
          createdBy: null,
          updatedAt: null,
          updatedBy: null,
          deletedFlag: false,
        };
      } else if (key === "status") {
        this.status = "active";
      } else if (key === "country") {
        this.country = "IN";
      } else {
        this[key] = null;
      }
    }

    if (isCreation) {
      this.id = data.id || crypto.randomUUID();
      this.locationCode = data.locationCode || null;
      this.locationName = data.locationName || null;
      this.address = data.address || null;
      this.country = data.country || "IN";
      this.state = data.state || null;
      this.city = data.city || null;
      this.pinCode = data.pinCode || null;
      this.status = data.status || "active";
      this.companyId = data.companyId || null;
      this.company = data.company || null;

      const now = new Date().toISOString();
      this.metadata = {
        createdAt: data.metadata?.createdAt || data.createdAt || now,
        createdBy: data.metadata?.createdBy || data.createdBy || "system",
        updatedAt: data.metadata?.updatedAt || data.updatedAt || now,
        updatedBy: data.metadata?.updatedBy || data.updatedBy || "system",
        deletedFlag: data.metadata?.deletedFlag ?? false,
      };
    } else {
      for (const key of Object.keys(data)) {
        if (!LocationModel.ALLOWED_KEYS.includes(key)) continue;

        if (key === "metadata") {
          this.metadata = { ...this.metadata, ...(data.metadata || {}) };
        } else {
          this[key] = data[key];
        }
      }
      if (data.createdAt) this.metadata.createdAt = data.createdAt;
      if (data.createdBy) this.metadata.createdBy = data.createdBy;
      if (data.updatedAt) this.metadata.updatedAt = data.updatedAt;
      if (data.updatedBy) this.metadata.updatedBy = data.updatedBy;
    }
  }

  isValid() {
    if (!this.locationName || !String(this.locationName).trim()) return false;
    if (!this.locationCode || !String(this.locationCode).trim()) return false;
    return true;
  }

  toPayload() {
    const payload = {};
    for (const key of LocationModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        payload.metadata = {};
        for (const mk of LocationModel.ALLOWED_METADATA_KEYS) {
          payload.metadata[mk] = this.metadata?.[mk] ?? (mk === "deletedFlag" ? false : null);
        }
      } else if (this[key] !== undefined) {
        payload[key] = this[key];
      }
    }
    return payload;
  }

  toJSON() {
    return this.toPayload();
  }
}
